export enum TenantFeatureFlags {
  RECON_TENANT = "d4620c30-c962-4bb0-a00d-6b0026384d62",
}

// Tenants that can select bank interface (FINTS vs XS2A)
export const BANK_INTERFACE_SELECTION_ENABLED_TENANTS = [
  "559db26c-b99b-4ca5-bad3-5367ba4a46c3",
  "b760a87a-6d76-4786-8f4e-47772b58836a",
  // TEST_FINTSSERVER_TENANT
];
